function Mail01({
  color = 'currentColor',
  w = 21,
  h = 20,
  strokeWidth = 0.670909
}: {
  color?: string
  w?: number
  h?: number
  strokeWidth?: number
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={w} height={h} viewBox="0 0 21 20" fill="none">
      <path d="M2.1665 5.83337L8.9706 10.5962C9.52158 10.9819 9.79707 11.1748 10.0967 11.2495C10.3614 11.3154 10.6383 11.3154 10.903 11.2495C11.2026 11.1748 11.4781 10.9819 12.0291 10.5962L18.8332 5.83337M6.1665 16.6667H14.8332C16.2333 16.6667 16.9334 16.6667 17.4681 16.3942C17.9386 16.1545 18.321 15.7721 18.5607 15.3017C18.8332 14.7669 18.8332 14.0668 18.8332 12.6667V7.33337C18.8332 5.93324 18.8332 5.23318 18.5607 4.6984C18.321 4.22799 17.9386 3.84554 17.4681 3.60586C16.9334 3.33337 16.2333 3.33337 14.8332 3.33337L6.1665 3.33337C4.76637 3.33337 4.06631 3.33337 3.53153 3.60586C3.06112 3.84554 2.67867 4.22799 2.43899 4.6984C2.1665 5.23318 2.1665 5.93324 2.1665 7.33337L2.1665 12.6667C2.1665 14.0668 2.1665 14.7669 2.43899 15.3017C2.67867 15.7721 3.06112 16.1545 3.53153 16.3942C4.06631 16.6667 4.76637 16.6667 6.1665 16.6667Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default Mail01
